import React from 'react'
import {
  Button,
  Grid,
  IconButton,
  Typography,
  withStyles
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Page } from 'components'
import ReactGA from "react-ga4";

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '100vh',

    gap: 10
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    width: '100%',
    maxWidth: '450px',
    textAlign: 'center',
  },
  code: {
    color: '#D2222D',
  }
})

const CampanhaInstrucoes = (props) => {
  const { classes } = props

  const handleClickPlayStore = () => {
    ReactGA.event({
      category: "Link Externo",
      action: "open_link_criamigos",
      label: "Criamigos",
    });

    window.open("https://play.google.com/store/apps/details?id=br.com.forcontrol.quierocafe&hl=pt_BR", "_blank");
  };

  const handleClickAppStore = () => {
    ReactGA.event({
      category: "Link Externo",
      action: "open_link_criamigos",
      label: "Criamigos",
    });

    window.open("https://apps.apple.com/us/app/quiero-fidelidade/id1582879059", "_blank");
  };

  return (
    <Page title="Instruções Campanha">
      <Grid container className={[classes.root, classes.flexColumn]}>
        <Grid item className={classes.flexColumn} style={{ margin: 20, gap: 10 }}>
          <Typography variant="h4" style={{ marginBottom: 10, textAlign: 'center' }}>
            Olá Quierido,
          </Typography>

          <Typography className={classes.text}>
            Para pontuar na campanha, você precisa acessar o nosso app <b>Quiero Fidelidade</b> e realizar o scan do QR Code. Utilize o botão de QR Code na parte superior do app:
          </Typography>

          <img
            src={require('../../img/campanha_instrucoes.png')}
            alt="Pontuar pelo menu superior"
            style={{
              width: 220,
              alignSelf: 'center',
              margin: '20px auto',
              display: 'block',
              borderRadius: 12,
            }}
          />

          <Typography className={classes.text}>
            Ou o menu Pontuar na menu inferior:
          </Typography>


          <img
            src={require('../../img/campanha_instrucoes2.png')}
            alt="Pontuar pelo menu inferior"
            style={{
              width: 220,
              alignSelf: 'center',
              margin: '20px auto',
              display: 'block',
              borderRadius: 12,
            }}
          />


          <Typography className={classes.text}>
            Se ainda não tem uma conta, é só fazer o cadastro, é rapidinho. Caso ainda não tenha baixo o app, vou deixar aqui abaixo os links.
          </Typography>

        </Grid>

        <Grid item style={{ margin: 10,  display: 'flex', gap: 10 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickPlayStore}
            startIcon={
              <img
                src={require('../../img/play_store.png')}
                alt="App Store"
                style={{ height: 24 }}
              />
            }
          >
            Play Store (Android)
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickAppStore}
            startIcon={
              <img
                src={require('../../img/app_store.png')}
                alt="App Store"
                style={{ height: 24 }}
              />
            }
          >
            App Store (iOS)
          </Button>
        </Grid>

      </Grid>
    </Page>
  )
}

CampanhaInstrucoes.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  const { loggingIn } = state.authentication
  return {
    loggingIn
  }
}
const connectedCampanhaInstrucoesPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(CampanhaInstrucoes))
)
export { connectedCampanhaInstrucoesPage as CampanhaInstrucoes }
